export default __webpack_public_path__ + "static/media/bg2.25f42605.jpg";